(() => {
  angular.module('finance').component('curlecPayoutQueueComponent', {
    templateUrl: require('./curlecPayoutQueue.component.html'),
    controller: CurlecPayoutQueueComponent,
    controllerAs: 'vm',
    bindings: {
      pageState: '=',
    },
  });

  CurlecPayoutQueueComponent.$inject = [];

  function CurlecPayoutQueueComponent() {
    const vm = this;

    vm.loading = 0;
    vm.queue = [];

    init();

    function init() {
      for (let i = 0; i < 3; i += 1) {
        vm.queue.push({
          paymentInstructionBatchNumber: 'PIB-C-0000-00000' + i,
          date: new Date(Date.now()).toISOString().split('T')[0],
          status: 'Pending',
        });
      }
    }
  }
})();
